import React from "react";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { CARD } from "./ui";

export default function EmptyState({ title = "Collecting data", children }: { title?: string; children?: React.ReactNode }) {
  return (
    <div className={`${CARD} p-10 flex flex-col items-center text-center`}>
      <div className="w-12 h-12 rounded-2xl bg-slate-100 dark:bg-slate-700 flex items-center justify-center text-slate-400 dark:text-slate-500">
        <HourglassEmptyIcon />
      </div>
      <p className="mt-3 text-sm font-semibold text-slate-700 dark:text-slate-200">{title}</p>
      <p className="mt-1 text-xs text-slate-400 dark:text-slate-500 max-w-sm">
        {children ?? "Collecting data — first numbers appear after the first full day"}
      </p>
    </div>
  );
}
